import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/hsa-calculator',
  component: () => import('../../routes/HsaCalculator.svelte'),
  card: {
    id: 'hsa-calculator',
    title: 'HSA Calculator',
    description: 'Project your Health Savings Account balance with the triple tax advantage — tax-deductible contributions, tax-free growth, and tax-free withdrawals for medical expenses.',
    icon: 'health_and_safety',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/hsa-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'HSA Calculator – Free Health Savings Account Growth Calculator',
    description: 'Free HSA calculator projects your Health Savings Account balance with the triple tax advantage. See tax-free growth, compare to taxable accounts, and plan for medical expenses.',
  },
};

export default meta;
